import { render, staticRenderFns } from "./SummaryDocumentData.vue?vue&type=template&id=32ce5693&scoped=true"
import script from "./SummaryDocumentData.vue?vue&type=script&lang=js"
export * from "./SummaryDocumentData.vue?vue&type=script&lang=js"
import style0 from "./SummaryDocumentData.vue?vue&type=style&index=0&id=32ce5693&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ce5693",
  null
  
)

export default component.exports